export default __webpack_public_path__ + "static/media/multisearch_light.22e4e0cd.svg";